<script setup>

const props = defineProps({
  options: Object,
  course: Object
})
const config = useRuntimeConfig()
const {search} = useLocationData()

const { $offcanvas } = useNuxtApp();
const { version } = useZigZag()
const { data, refresh } = await version(config.public.zigzagUrl)

const time = data.value ? data.value.t : 0;
const sha = data.value ? data.value.sha : 'versionnotfound';

const url = `${config.public.zigzagUrl}/app/layout/shell.html?sha=${sha}&t=${time}`;

const bsOffcanvas = ref();
const offcanvasStatus = ref(false)

const openDrawer = () => {
  location.href =  `#/reg-flow/product-availability?prodid=${props.course.pulseCourse.pulseId}&style=default`;
  openOffcanvas();
}

const closeOffcanvas = () => {
  offcanvasStatus.value = false;
  document.body.style.overflow = 'visible';
}

const openOffcanvas = () => {
  offcanvasStatus.value = true;
  document.body.style.overflow = 'hidden';
}

onMounted(() => {
  bsOffcanvas.value = document.getElementById('miniavcDrawerSlider');

  window.addEventListener('hashchange', function () {
    // Checking if the URL hash changed and hiding the drawer in case the prod Id is not present
    if (!window.location.hash.includes('prodid')) {
      closeOffcanvas();
    }
  });

  
})


const fields = props.options;
// Cheking for any custom field from the course collection
if (props.course.floatingBlock !== null) {
  if (props.course.floatingBlock.image && props.course.floatingBlock.image.data ) {    
    fields.image = props.course.floatingBlock.image.data.attributes;
  }
  if (props.course.floatingBlock.blockContent) {
    fields.blockContent = props.course.floatingBlock.blockContent;
  }
  if (props.course.floatingBlock.searchButton) {
    fields.buttonText = props.course.floatingBlock.searchButton.buttonText;
  }
  if (props.course.floatingBlock.mobileButtonText) {
    fields.mobileButtonText = props.course.floatingBlock.mobileButtonText;
  }  
  if (props.course.floatingBlock.subtext) {
    fields.subtext = props.course.floatingBlock.subtext;
  }
  if (props.course.floatingBlock.stickyFooterButtonText) {
    fields.stickyFooterButtonText = props.course.floatingBlock.stickyFooterButtonText;
  }
}

</script>

<template>
  
  <CourseBaseFloatingBlock>
    <template v-slot:block-body>
      <div class="extra-title">
        <NuxtImg :src="fields.image.url" class="card-image" v-if="fields" />
        <div class="text-center mt-2" v-html="fields.blockContent"></div>
        <div class="text-center">
          <button :class="`btn btn-primary`" @click="openDrawer">{{ fields.buttonText }}</button>
        </div>
      </div>
    </template>
    <template v-slot:block-subtext>
      <div class="text-center mt-3" v-html="fields.subtext" v-if="fields.subtext"></div>
    </template>
    <template v-slot:mobile-body>
      <button :class="`btn btn-primary w-100`" @click="openDrawer">{{ fields.stickyFooterButtonText ? fields.stickyFooterButtonText : fields.mobileButtonText }}</button>
    </template>
  </CourseBaseFloatingBlock> 

  <div class="offcanvas offcanvas-end www-drawer w-100" :class="{'show': offcanvasStatus}" id="miniavcDrawerSlider" tabindex="-1"  aria-labelledby="offcanvasLabel">
    <div class="offcanvas-header">
      <h5 class="offcanvas-title" id="offcanvasLabel"></h5>
      <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close" @click="closeOffcanvas"></button>
    </div>
    <div class="offcanvas-body">
      <div id="www-spa-container" class="www-pulseapp mini-avc" data-page="/reg-flow/product-availability">
        <div class="pulseapp">
          <AngularSpinner />
          <div class="shell-container" :ng-include="`'${url}'`">
            <div class="box-wrapper">
              <span class="spinner"></span>
              <strong>Loading...</strong>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  </div>
  <div class="offcanvas-backdrop fade" :class="{'show': offcanvasStatus, 'd-none': !offcanvasStatus}"></div>
  
</template>

<style lang="scss" >

.location-results {
  h6 {
    font-weight: 700;
  }
  .distance,
  .residency,
  legend {
    font-size: 14px;
  }
  .btn-select {
    min-width: min-content;
  }
  .location-status {
    &--open {
      color: #30ad3e;
      &::before {
        content: '';
        display: inline-block;
        width: 6px;
        height: 6px;
        margin-right: 4px;
        margin-bottom: 2px;
        background-color: #60dd1e;
        border-radius: 100%;
      }
    }

    &--no-dot::before {
      display: none;
    }

    &--coming-soon {
      color: #aa9314 !important;
    }

    &--waitlist {
      color: #ad307d !important;
    }

    &[class*="--coming-"]:not([class*="soon"]) {
      color: #a37070 !important; 
    }
  }
  
}

.offcanvas {
  transition: all 0.8s ease-in-out;
  box-shadow: -0.5rem 0 1rem rgba(0, 0, 0, 0.5);
}

.www-drawer {
  max-width: 650px;
  // Temporary styles to avoid conflicts with ZigZag  
  .www-pulseapp  {
    .btn {
      border: none;
      text-decoration: none;
      .text-nowrap {
        font-weight: 400;
      }
      .btn-pill-lg {
        padding: 0.8rem 2rem 0.8rem 2rem;
        font-size: 0.75rem;
      }
    }
    .btn-close {
      width: auto;
      background: none;
      color: inherit;
      
    }  
  }
  
}




</style>